import React from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';

import classes from './style.module.scss';
import access from '@/components/common/icons/access.svg';
import chat from '@/components/common/icons/chat.svg';
import email from '@/components/common/icons/email.svg';
import phone from '@/components/common/icons/phone.svg';
import loginImage from '@/png-icons/login.png';

const ClientSuccessComponent = ({ franchise }) => {
  const intl = useIntl();

  return (
    <div className={classes.successPage}>
      <div className={classes.container}>
        <h2 className={classes.title}>{intl.formatMessage({ id: 'CLIENT_SUCCESS.REGISTRATION_COMPLETED' })}</h2>
        <h3>{intl.formatMessage({ id: 'CLIENT_SUCCESS.WELCOME_MESSAGE' })}</h3>
        <p>{intl.formatMessage({ id: 'CLIENT_SUCCESS.EMAIL_SENT' })}</p>
        <p>{intl.formatMessage({ id: 'CLIENT_SUCCESS.CHECK_EMAIL_INSTRUCTIONS' })}</p>

        <div className={classes.content}>
          <h4>
            <img className={classes.icon} src={chat} alt="" />
            {intl.formatMessage({ id: 'CLIENT_SUCCESS.SUPPORT' })}
          </h4>
          <p>
            {intl.formatMessage({ id: 'CLIENT_SUCCESS.SUPPORT_MESSAGE' })}{' '}
            <span className={classes.uppercase}>{franchise?.name}</span>.
          </p>
          <p>{intl.formatMessage({ id: 'CLIENT_SUCCESS.CONTACT_MESSAGE' })}</p>
          <p>
            <img className={classes.icon} src={phone} alt="" />
            {franchise.phone}
          </p>
          <p>
            <img className={classes.icon} src={email} alt="" />
            {franchise.email}
          </p>
          
          <h4>
            <img className={classes.icon} src={access} alt="" />
            {intl.formatMessage({ id: 'CLIENT_SUCCESS.FIRST_ACCESS' })}
          </h4>
          <p>
            {intl.formatMessage({ id: 'CLIENT_SUCCESS.FIRST_ACCESS_INSTRUCTIONS' })}
          </p>
          <img className={classes.image} src={loginImage} alt="" />
        </div>

        <p>
          {intl.formatMessage({ id: 'CLIENT_SUCCESS.PANEL_ACCESS_INSTRUCTIONS' })}
          <a className={classes.link} href="https://painel.redevistorias.com.br/" target="_blank" rel="noreferrer">
            www.painel.redevistorias.com.br
          </a>{' '}
          {intl.formatMessage({ id: 'CLIENT_SUCCESS.PANEL_ACCESS_ALTERNATIVE' })}
        </p>
        <p>
          {intl.formatMessage({ id: 'CLIENT_SUCCESS.TUTORIAL_INSTRUCTIONS' })}
          <a className={classes.link} href="https://s.vistori.as/criando_um_pedido_tutorial.pdf" target="_blank" rel="noreferrer">
            {intl.formatMessage({ id: 'CLIENT_SUCCESS.TUTORIAL_LINK' })}
          </a>
        </p>
        <img className={classes.image} src="/assets/img/rv-logo.png" alt="Logo Rede Vistorias" />
      </div>
    </div>
  );
};

ClientSuccessComponent.propTypes = {
  franchise: PropTypes.object,
};

ClientSuccessComponent.defaultProps = {
  franchise: null,
};

export default ClientSuccessComponent;
